var _defs, _rect, _line, _text, _text2, _text3, _g, _path, _g2, _path2, _g3, _path3, _g4, _text4, _text5, _g5, _path4, _g6, _path5, _g7, _path6, _g8, _path7, _g9, _text6, _text7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShadowAiAtWorkPaths(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1040 560",
    width: 1040,
    height: 560,
    role: "img",
    "aria-label": "Two paths for the same request: the shadow path where an employee uses a personal AI account with no logging, and the governed path where the same request runs through the BossDrop AI layer with scoped access, an approval gate, and an audit trail",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pbg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#121020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171523"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pai",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fd8f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f7fd0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pgold",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe9a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2b24a"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "parr",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L10 5 L0 10 z",
    fill: "#8d87a3"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "parrW",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L10 5 L0 10 z",
    fill: "#f6a35a"
  })), /*#__PURE__*/React.createElement("style", null, "\n      .t   { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:800; fill:#f4f0fc; }\n      .cap { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#b8b2cc; }\n      .lay { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#efe9fa; }\n      .pill{ font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#121020; }\n      .k   { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#cfc3ee; }\n      .bad { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#f6a35a; }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1040,
    height: 560,
    rx: 18,
    fill: "url(#pbg)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 44,
    x2: 520,
    y2: 516,
    stroke: "#2a2547",
    strokeWidth: 1.5,
    strokeDasharray: "6 8"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 40,
    className: "cap",
    fontSize: 15,
    opacity: 0.9
  }, "Same request: \"summarize this week's account risks and update the owners.\"")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 84,
    className: "t",
    fontSize: 25
  }, "The shadow path")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 112,
    className: "cap",
    fontSize: 15
  }, "Fast today. Invisible tomorrow.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 168,
    r: 26,
    fill: "url(#pgold)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 160,
    r: 9,
    fill: "#121020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 182 a15 12 0 0 1 30 0 z",
    fill: "#121020"
  }), /*#__PURE__*/React.createElement("text", {
    x: 136,
    y: 163,
    className: "lay",
    fontSize: 15
  }, "Employee"), /*#__PURE__*/React.createElement("text", {
    x: 136,
    y: 183,
    className: "cap",
    fontSize: 13
  }, "needs it done now"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126 168 H 216",
    stroke: "#8d87a3",
    strokeWidth: 2.5,
    fill: "none",
    markerEnd: "url(#parr)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 140,
    width: 244,
    height: 56,
    rx: 12,
    fill: "#1d1a2e",
    stroke: "#4c4380"
  }), /*#__PURE__*/React.createElement("text", {
    x: 344,
    y: 164,
    textAnchor: "middle",
    className: "lay",
    fontSize: 15
  }, "Personal AI account"), /*#__PURE__*/React.createElement("text", {
    x: 344,
    y: 184,
    textAnchor: "middle",
    className: "cap",
    fontSize: 13
  }, "outside the company boundary"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M344 196 V 244",
    stroke: "#8d87a3",
    strokeWidth: 2.5,
    fill: "none",
    markerEnd: "url(#parr)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 250,
    width: 244,
    height: 56,
    rx: 12,
    fill: "#1d1a2e",
    stroke: "#4c4380"
  }), /*#__PURE__*/React.createElement("text", {
    x: 344,
    y: 274,
    textAnchor: "middle",
    className: "lay",
    fontSize: 15
  }, "Answer pasted back into work"), /*#__PURE__*/React.createElement("text", {
    x: 344,
    y: 294,
    textAnchor: "middle",
    className: "cap",
    fontSize: 13
  }, "context stays in one person's head"))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M344 306 V 350",
    stroke: "#f6a35a",
    strokeWidth: 2.5,
    fill: "none",
    markerEnd: "url(#parrW)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 356,
    width: 406,
    height: 126,
    rx: 14,
    fill: "#17121c",
    stroke: "#5a3b2a"
  }), /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 384,
    className: "bad",
    fontSize: 15
  }, "What you are left with"), /*#__PURE__*/React.createElement("g", {
    className: "cap",
    fontSize: 14
  }, /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 410
  }, "Company data crossed a boundary nobody approved"), /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 434
  }, "No log of what ran, on what, or who decided"), /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 458
  }, "The workflow dies when that person changes teams")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 580,
    y: 84,
    className: "t",
    fontSize: 25
  }, "The governed path")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 580,
    y: 112,
    className: "cap",
    fontSize: 15
  }, "Same speed. Now it is an asset.")), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 616,
    cy: 168,
    r: 26,
    fill: "url(#pgold)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 616,
    cy: 160,
    r: 9,
    fill: "#121020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601 182 a15 12 0 0 1 30 0 z",
    fill: "#121020"
  }), /*#__PURE__*/React.createElement("text", {
    x: 656,
    y: 163,
    className: "lay",
    fontSize: 15
  }, "Employee"), /*#__PURE__*/React.createElement("text", {
    x: 656,
    y: 183,
    className: "cap",
    fontSize: 13
  }, "same request, same day"))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M646 168 H 726",
    stroke: "url(#pai)",
    strokeWidth: 3,
    fill: "none",
    markerEnd: "url(#parr)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 732,
    y: 142,
    width: 248,
    height: 52,
    rx: 26,
    fill: "url(#pai)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 856,
    y: 174,
    textAnchor: "middle",
    className: "pill",
    fontSize: 16
  }, "BossDrop AI layer"))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M856 194 V 234",
    stroke: "url(#pai)",
    strokeWidth: 3,
    fill: "none",
    markerEnd: "url(#parr)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 240,
    width: 400,
    height: 60,
    rx: 12,
    fill: "#1d1a2e",
    stroke: "#665a9c"
  }), /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 264,
    className: "lay",
    fontSize: 15
  }, "Scoped access to the stack you already run"), /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 286,
    className: "cap",
    fontSize: 13
  }, "tasks, chat, calendar, docs \u2014 least privilege, read first"))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M780 300 V 336",
    stroke: "url(#pai)",
    strokeWidth: 3,
    fill: "none",
    markerEnd: "url(#parr)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 342,
    width: 400,
    height: 60,
    rx: 12,
    fill: "#1d1a2e",
    stroke: "#665a9c"
  }), /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 366,
    className: "lay",
    fontSize: 15
  }, "Approval gate on anything that changes the world"), /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 388,
    className: "cap",
    fontSize: 13
  }, "propose first; a named human approves high-impact actions"))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M780 402 V 438",
    stroke: "url(#pai)",
    strokeWidth: 3,
    fill: "none",
    markerEnd: "url(#parr)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 444,
    width: 400,
    height: 60,
    rx: 12,
    fill: "#171523",
    stroke: "#665a9c"
  }), /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 468,
    className: "k",
    fontSize: 15
  }, "Audit trail + reusable runbook"), /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 490,
    className: "cap",
    fontSize: 13
  }, "what triggered it, what changed, who approved \u2014 repeatable"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 524,
    className: "cap",
    fontSize: 14
  }, "The demand is identical on both sides. Only the path differs.")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 546,
    className: "k",
    fontSize: 14,
    opacity: 0.95
  }, "Shadow AI is a routing problem, not a discipline problem.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowAiAtWorkPaths);
export default __webpack_public_path__ + "static/media/shadow-ai-at-work-paths.1009a38b80241a253039512ab5e9c793.svg";
export { ForwardRef as ReactComponent };